module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsJDBIH9J4ACAAAANNJREFUSMft1jFKxGAQhuEnMaSztswJbGwsFYRcJLmBoqfJBfQGbnBt1RWMeIJ0dq7dplmLTSCNXZLqf2FghoF5YaqPAwnu8I4d9hPVDpv+dmIke55Q8l+tkSS4wUWWZaqqcnV6bErqz19FUWjb9hLXUf/Gs7quJ5cNrJqtPM9hE/V/TvffL+YkOjmHLkZqOdLYwgRhEAZhEAZhEAbhQdgt6OtifA3pai5WzXZomxj3UJbleDEZjx8/yrIcxochCK8XCMJPOBqn71u8zRD1X/vbCfwBKReIVEUwX1MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_exencioncanon_borde.png
// module id = UfXV
// module chunks = 0